import React from 'react';
import { useRecoilState } from 'recoil';

import { Globals, getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { updateMyTheme } from "root/DataFunctions/ChildDataFns";
import { childThemeState } from 'root/recoil/childThemeState';
import { childDrawerState } from 'root/recoil/childDrawerState';

const ThemeImage = ({theme}) => {
    const [childTheme, setChildTheme] = useRecoilState(childThemeState)
    const [childDrawer, setChildDrawer] = useRecoilState(childDrawerState)

    const onChildDrawerThemeImage = (theme) => {
        updateMyTheme(theme.id, (response) =>
        {
            setChildTheme(getDataFromResponse(response)[0]);
        });

        setChildDrawer(!childDrawer)
    }

    const url = Globals.BaseURL + "/images/themes/" + theme.background

    return(
        <div 
            className={theme.background === childTheme.background ? "sideDrawer_theme_item active" : "sideDrawer_theme_item"} 
        >
            <span className="sideDrawer_theme_item_wrap"
                onClick={() => onChildDrawerThemeImage(theme)}
            >
                <img src={url} />
            </span>
        </div>
    )
}

export default ThemeImage;